module.exports = __webpack_public_path__ + "img/greenback.526e4f0d.png";